import { useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
// import Collapse from "@mui/material/Collapse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GitHubIcon from "@mui/icons-material/GitHub";
import { IconButton } from "@mui/material";
import { useTheme } from "../../theme-context";

const ProjectCard = ({ project }) => {
  const [expanded, setExpanded] = useState(false);
  const teamLeadRaw = project["Team Lead"] || project["Team Leads"] || "";
  const teamLead = typeof teamLeadRaw === "string" ? teamLeadRaw.trim() : "";
  const teamLeadLabel = teamLead.includes(",") ? "Team Leads" : "Team Lead";

  const theme = useTheme();

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Box sx={{ minWidth: 275 }} className="w-full">
      <Card
        variant="outlined"
        onClick={handleExpandClick}
        sx={{
          cursor: "pointer",
          position: "relative",
          backgroundColor: "transparent",
          border: "1px solid white",
        }}
        className="!text-white"
      >
        <CardContent>
          <h2 className="text-heading-sm py-2 lg:py-4 font-catchy font-bold">
            {project["Title"]}
            {project["Link"] && (
              <a
                href={project["Link"]}
                target="_blank"
                rel="noopener noreferrer"
                className="ml-2"
                tabIndex="0"
              >
                <GitHubIcon sx={{ fontSize: "1.5rem", color: "white" }} />
              </a>
            )}
          </h2>
          <div className="flex flex-wrap gap-2">
            {project["Tags"].map((tag, index) => (
              <span
                key={index}
                className={`text-body-xs lg:text-body-sm px-3 py-1 rounded-full ${theme.dust} ${theme.text_black} font-catchy`}
              >
                {tag}
              </span>
            ))}
          </div>
          <p className="text-body-md font-serif py-2">{project["Summary"]}</p>
          {teamLead && (
            <p className="text-body-sm py-1 lg:text-body-md font-serif">
              {teamLeadLabel}: {teamLead}
            </p>
          )}
          <p className="text-body-sm py-1 lg:text-body-md font-serif">
            Contributors: {project["Contributors"]}
          </p>
          <IconButton
            sx={{
              visibility: "hidden",
              position: "absolute",
              top: "16px",
              right: "16px",
              transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s",
            }}
            disableRipple
          >
            <ExpandMoreIcon />
          </IconButton>
        </CardContent>
        {/* <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Typography sx={{ marginBottom: 2 }}>Method:</Typography>
          </CardContent>
        </Collapse> */}
      </Card>
    </Box>
  );
};

export default ProjectCard;
